const IMAGE_SIZE_BUCKETS = {
  iconSmall: "32px",
  iconLarge: "64px",
  thumb: "200px",
  card: "(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 480px",
  full: "100vw",
} as const;

export const IMAGE_SIZES = {
  icon16: IMAGE_SIZE_BUCKETS.iconSmall,
  icon20: IMAGE_SIZE_BUCKETS.iconSmall,
  icon24: IMAGE_SIZE_BUCKETS.iconSmall,
  icon32: IMAGE_SIZE_BUCKETS.iconSmall,
  icon40: IMAGE_SIZE_BUCKETS.iconLarge,
  icon48: IMAGE_SIZE_BUCKETS.iconLarge,
  icon64: IMAGE_SIZE_BUCKETS.iconLarge,
  thumb80: IMAGE_SIZE_BUCKETS.thumb,
  thumb96: IMAGE_SIZE_BUCKETS.thumb,
  thumb128: IMAGE_SIZE_BUCKETS.thumb,
  thumb160: IMAGE_SIZE_BUCKETS.thumb,
  thumb200: IMAGE_SIZE_BUCKETS.thumb,
  cardSmall: IMAGE_SIZE_BUCKETS.card,
  cardMedium: IMAGE_SIZE_BUCKETS.card,
  cardLarge: IMAGE_SIZE_BUCKETS.full,
  hero: IMAGE_SIZE_BUCKETS.full,
  banner: IMAGE_SIZE_BUCKETS.full,
  full: IMAGE_SIZE_BUCKETS.full,
};
